"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _templateObject = _taggedTemplateLiteral(["\n  margin-left: 10px;\n  letter-spacing: 0.9px;\n  -webkit-font-smoothing: antialiased;\n  padding: 3px 15px;\n\n  &:first-child {\n    margin-left: 0;\n  }\n"], ["\n  margin-left: 10px;\n  letter-spacing: 0.9px;\n  -webkit-font-smoothing: antialiased;\n  padding: 3px 15px;\n\n  &:first-child {\n    margin-left: 0;\n  }\n"]);

var _styledComponents = require("styled-components");

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _Tag = require("./Tag");

var _Tag2 = _interopRequireDefault(_Tag);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var CardTag = (0, _styledComponents2.default)(_Tag2.default).withConfig({
  displayName: "CardTag",
  componentId: "sc-11brf0u-0"
})(_templateObject);

exports.default = CardTag;


//////////////////
// WEBPACK FOOTER
// ./~/buoy-tag/dist/components/CardTag.js
// module id = 447
// module chunks = 168707334958949